import React from "react";

import { useIntl } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";

import { ReactComponent as IconMute18 } from "../../icons/icon/18/a-icon-mute-18.svg";
import { ReactComponent as IconUnmute18 } from "../../icons/icon/18/a-icon-unmute-18.svg";
import IconButton from "../button/iconButton";

const MuteButton = ({ muted, setMuted }) => {
  const intl = useIntl();

  return (
    <IconButton
      onClick={() => setMuted((prevState) => !prevState)}
      iconOnly
      className="video-background-player__mute-button"
      variant="inverted-light"
      title={intl.formatMessage({ id: muted ? "video.toggle_unmute.title" : "video.toggle_mute.title" })}
    >
      {muted ? <IconUnmute18 /> : <IconMute18 />}
    </IconButton>
  );
};

MuteButton.propTypes = {
  muted: PropTypes.bool.isRequired,
  setMuted: PropTypes.func.isRequired,
};

export default MuteButton;
